import { TreeGridTranslations } from "../../hooks/use-translations"
import { updateRowCountInToolbar } from "./utils"

type MakeOnFilterFinishArgs = {
  translations: TreeGridTranslations
  gridId: "home" | "holidays" | "projects" | "tasks" | "project-templates" | "task-tree-grid" | "todo-list"
}

export const makeOnFilterFinish = (args: MakeOnFilterFinishArgs) => (grid: TGrid) => {
  const summaryText =
    args.gridId === "projects"
      ? args.translations.toolbarProjectListSummaryText
      : args.gridId === "tasks"
      ? args.translations.toolbarTaskListSummaryText
      : args.gridId === "project-templates"
      ? args.translations.toolbarProjectListSummaryText
      : args.gridId === "task-tree-grid"
      ? args.translations.toolbarTaskListSummaryText
      : args.gridId === "todo-list"
      ? args.translations.toolbarTodoListSummaryText
      : args.translations.toolbarActivitiesListSummaryText

  updateRowCountInToolbar(grid, summaryText)
}
